// src/components/ui/toggle-group.jsx
// shadcn/ui ToggleGroup on Radix (from the installed radix-ui package), in the
// graphite style (design decision D9): a recessed track, the selected item a
// light pill. Keyboard: arrow keys move between items, Space/Enter selects.
//
// type="single" lets a click on the active item clear the value; callers that
// always need a value ignore the empty string: onValueChange={(v) => v && set(v)}.
import * as React from "react"
import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui"
import { cn } from "@/lib/utils"

const ToggleGroup = React.forwardRef(({ className, ...props }, ref) => (
  <ToggleGroupPrimitive.Root
    ref={ref}
    className={cn("flex gap-0.5 rounded-xl bg-[var(--ui-inset)] p-[3px]", className)}
    {...props}
  />
))
ToggleGroup.displayName = "ToggleGroup"

const ToggleGroupItem = React.forwardRef(({ className, ...props }, ref) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      "flex h-[30px] flex-1 items-center justify-center whitespace-nowrap rounded-[9px] px-3 text-[12.5px] text-[var(--ui-text-muted)]",
      "transition-colors hover:text-[var(--ui-text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30",
      "data-[state=on]:bg-[var(--ui-selected)] data-[state=on]:font-semibold data-[state=on]:text-[var(--ui-selected-text)]",
      "disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:text-[var(--ui-text-muted)]",
      className
    )}
    {...props}
  />
))
ToggleGroupItem.displayName = "ToggleGroupItem"

export { ToggleGroup, ToggleGroupItem }